import React, { useState, useEffect } from 'react';
import { useParams, useNavigate, Link } from 'react-router-dom';
import { HTTP } from '../../api/http-common';
import Swal from 'sweetalert2';
import Loader from '../../components/loader';
import 'sweetalert2/dist/sweetalert2.min.css';
import ErrorHandlingComponent from '../../components/ErrorHandlingComponent';
import useUserRoleEffect from '../../components/userRoleEffect';
import { CommonTitle } from '../../components/commonComponents';

export default function HeroPosterAddUpdate() {
  const navigate = useNavigate();
  const { id } = useParams();
  const [error, setError] = useState(null);
  const [pageType, setPageType] = useState('Add');
  const [title, setTitle] = useState('');
  const [titleError, setTitleError] = useState('');
  const [description, setDescription] = useState('');
  const [descriptionError, setDescriptionError] = useState('');
  const [isActive, setIsActive] = useState(false);
  const [isAa, setIsAa] = useState(false);
  const [buttonText, setButtonText] = useState('Click Me!');
  const [buttonTextError, setButtonTextError] = useState('');
  const [isButtonVisible, setIsButtonVisible] = useState(false);
  const [mediaUrl, setMediaUrl] = useState('');
  const [mediaUrlError, setMediaUrlError] = useState('');
  const [createdBy, setCreatedBy] = useState(0);
  const [isLoading, setIsLoading] = useState(false);
  const access_token = localStorage.getItem('access_token');
  const userObj = JSON.parse(localStorage.getItem('userObj'));
  const userRole = userObj?.role?.id;

  useUserRoleEffect(userRole);

  const handleStatusCheckboxChange = () => {
    setIsActive((prev) => !prev);
  };

  const handleButtonVisibleCheckboxChange = () => {
    setIsButtonVisible((prev) => !prev);
  };

  const handleIsAaCheckboxChange = () => {
    setIsAa((prev) => !prev);
  };

  const loadHeroPosterData = async () => {
    try {
      setIsLoading(true);
      const config = {
        headers: { 'Content-Type': 'application/json', token: access_token },
      };
      const response = await HTTP.get(`hero_poster/${id}`, config);
      if (response.status === 200) {
        const { content } = response.data;
        setTitle(content.title || '');
        setDescription(content.description || '');
        setIsActive(content.is_active || false);
        setButtonText(content.button_text || 'Click Me!');
        setIsButtonVisible(content.is_button_visible || false);
        setMediaUrl(content.media_url || '');
        setCreatedBy(content.created_by || 0);
        setIsAa(content.is_aa || false);
      } else if (response.status === 204) {
        Swal.fire('', 'Hero poster Not Found', 'error');
      }
    } catch (error) {
      setError(error);
      Swal.fire('', 'Error loading hero poster data', 'error');
    } finally {
      setIsLoading(false);
    }
  };

  const showSubmitButton = () => {
    const content_created_by = createdBy;
    const login_user_id = parseInt(userObj.id);
    const user_role = parseInt(userObj.role.id);
    const cid = id;

    if (cid === 'add' || cid === 'undefined' || !cid || cid === ':id') {
      return true;
    }
    if (user_role === 1) {
      return true;
    } else if ([2, 3, 4].includes(user_role)) {
      return login_user_id === content_created_by;
    }
    return false;
  };

  useEffect(() => {
    const cid = id;
    if (cid === 'add' || cid === 'undefined' || !cid || cid === ':id') {
      setPageType('Add');
      setIsLoading(false);
    } else {
      setPageType('Update');
      loadHeroPosterData();
    }
  }, [id]); // Dependency on `id` to re-run when the route param changes

  const resetValidationErrors = () => {
    setTitleError('');
    setDescriptionError('');
    setMediaUrlError('');
    setButtonTextError('');
  };

  const validateField = () => {
    resetValidationErrors();
    let checked = true;

    if (!title) {
      setTitleError('Please enter title');
      checked = false;
    } else if (title.length < 5) {
      setTitleError('Please enter minimum 5 characters');
      checked = false;
    } else if (title.length > 200) {
      setTitleError('Max character limit is 200');
      checked = false;
    }

    if (!buttonText) {
      setButtonTextError('Please enter text');
      checked = false;
    } else if (buttonText.length < 2) {
      setButtonTextError('Please enter minimum 2 characters');
      checked = false;
    } else if (buttonText.length > 10) {
      setButtonTextError('Max character limit is 10');
      checked = false;
    }

    if (!description) {
      setDescriptionError('Please enter description');
      checked = false;
    } else if (description.length < 5) {
      setDescriptionError('Minimum 5 character required');
      checked = false;
    } else if (description.length > 500) {
      setDescriptionError('Max character limit 500');
      checked = false;
    }

    if (!mediaUrl) {
      setMediaUrlError('Please enter Video Id');
      checked = false;
    } else if (mediaUrl.length !== 13) {
      setMediaUrlError('Required character should be 13');
      checked = false;
    }

    return checked;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validateField()) return;

    try {
      setIsLoading(true);
      const config = {
        headers: { 'Content-Type': 'multipart/form-data', token: access_token },
      };
      const cid = id === 'add' || id === 'undefined' || !id || id === ':id' ? 0 : id;

      const formData = new FormData();
      formData.append('title', title);
      formData.append('description', description);
      formData.append('media_url', mediaUrl);
      formData.append('button_text', buttonText);
      formData.append('is_button_visible', isButtonVisible);
      formData.append('is_active', isActive);
      formData.append('is_aa', isAa);

      const response = await HTTP.put(`hero_poster/create/update/${cid}`, formData, config);
      if (response.status === 200) {
        Swal.fire('', response.data.message, 'success');
        navigate('/heroposter/list');
      } else if (response.status === 204) {
        Swal.fire('', 'Hero poster Not Found', 'error');
      } else if (response.status === 403) {
        Swal.fire('', response.data.content, 'error');
      }
    } catch (error) {
      setError(error);
      Swal.fire('', 'Error submitting hero poster', 'error');
      loadHeroPosterData(); // Reload data in case of error
    } finally {
      setIsLoading(false);
    }
  };

  const handleBack = () => {
    navigate('/heroposter/list');
  };

  if (isLoading) {
    return <Loader />;
  }

  return (
    <>
      {error && <ErrorHandlingComponent err={error} />}
      <div className="post-upload-wrapper">
        <div className="d-flex justify-content-between">
          <CommonTitle PageTitle="Hero Poster" />
          <Link to="/heroposter/list">
            <span className="video-page-icons"></span>
            <span>Back</span>
          </Link>
        </div>
        <div className="post-upload-main">
          <div className="headline col-xl-12 my-3">
            <label htmlFor="head_line">Title</label>
            <input
              type="text"
              id="head_line"
              className="form-input"
              value={title}
              onChange={(e) => setTitle(e.target.value)}
            />
            {titleError && <span className="error-message">{titleError}</span>}
          </div>
          <div className="intro col-xl-12 my-3">
            <label htmlFor="intro">Description</label>
            <textarea
              className="form-input"
              id="intro"
              value={description}
              onChange={(e) => setDescription(e.target.value)}
            ></textarea>
            {descriptionError && <span className="error-message">{descriptionError}</span>}
          </div>
          <div className="media_url col-xl-12 my-3">
            <label htmlFor="vodeo_id">Video ID</label>
            <input
              type="text"
              id="vodeo_id"
              className="form-input"
              value={mediaUrl}
              onChange={(e) => setMediaUrl(e.target.value)}
            />
            {mediaUrlError && <span className="error-message">{mediaUrlError}</span>}
          </div>
          <div className="headline col-xl-12 my-3">
            <label htmlFor="button_text">Button Text</label>
            <input
              type="text"
              id="button_text"
              className="form-input"
              value={buttonText}
              onChange={(e) => setButtonText(e.target.value)}
            />
            {buttonTextError && <span className="error-message">{buttonTextError}</span>}
          </div>
          <div className="my-2">
            <label htmlFor="is_button_visible">Button Visible</label>
            <input
              type="checkbox"
              id="is_button_visible"
              checked={isButtonVisible}
              onChange={handleButtonVisibleCheckboxChange}
            />
          </div>
          <div className="my-2">
            <label htmlFor="is_active">Is Active</label>
            <input
              type="checkbox"
              id="is_active"
              checked={isActive}
              onChange={handleStatusCheckboxChange}
            />
          </div>
          <div className="my-2">
            <label htmlFor="is_aa">Is AA</label>
            <input
              type="checkbox"
              id="is_aa"
              checked={isAa}
              onChange={handleIsAaCheckboxChange}
            />
          </div>
          <div className="d-flex justify-content-center">
            {showSubmitButton() && (
              <button type="submit" className="form-submit button-design" onClick={handleSubmit}>
                Submit
              </button>
            )}
            <button className="form-submit button-design" onClick={handleBack}>
              <span className="text-white">Back</span>
            </button>
          </div>
        </div>
      </div>
    </>
  );
}